<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Atölyeler</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="openDialog()">
        <v-icon left>add</v-icon>Atölye Ekle
      </v-btn>
    </v-toolbar>

    <v-data-table :headers="headers" :items="atolyeler" :loading="loading" hide-actions class="elevation-1">
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.notes }}</td>
        <td class="text-xs-right">
          <v-icon small class="mr-2" color="blue" @click="openDialog(props.item)">edit</v-icon>
          <v-icon small color="red" @click="deleteAtolye(props.item)">delete</v-icon>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="480px" persistent>
      <v-card>
        <v-card-title><span class="headline">{{ editing.id ? 'Atölye Düzenle' : 'Atölye Ekle' }}</span></v-card-title>
        <v-card-text>
          <v-text-field v-model="editing.name" label="Atölye Adı" required></v-text-field>
          <v-textarea v-model="editing.notes" label="Not" rows="2" auto-grow></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">İptal</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      saving: false,
      headers: [
        { text: 'Atölye', value: 'name', sortable: false },
        { text: 'Not', value: 'notes', sortable: false },
        { text: 'İşlem', value: 'actions', sortable: false, align: 'right' },
      ],
      dialog: false,
      editing: { id: null, name: '', notes: '' },
    };
  },
  computed: {
    atolyeler() { return this.$store.getters['atolye/atolyeler']; },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try { await this.$store.dispatch('atolye/getAtolyeler'); } finally { this.loading = false; }
    },
    openDialog(item) {
      this.editing = item ? { id: item.id, name: item.name, notes: item.notes } : { id: null, name: '', notes: '' };
      this.dialog = true;
    },
    async save() {
      if (!this.editing.name) { this.notify('Atölye adı zorunludur.'); return; }
      this.saving = true;
      try {
        if (this.editing.id) {
          await this.$store.dispatch('atolye/updateAtolye', { id: this.editing.id, payload: { name: this.editing.name, notes: this.editing.notes } });
        } else {
          await this.$store.dispatch('atolye/createAtolye', { name: this.editing.name, notes: this.editing.notes });
        }
        this.dialog = false;
        await this.load();
      } catch (e) { this.notify(this.errMsg(e)); } finally { this.saving = false; }
    },
    async deleteAtolye(item) {
      if (!confirm(`${item.name} silinsin mi?`)) return;
      try { await this.$store.dispatch('atolye/deleteAtolye', item.id); await this.load(); }
      catch (e) { this.notify(this.errMsg(e)); }
    },
    errMsg(e) { return (e && e.response && e.response.data && e.response.data.message) || 'İşlem başarısız oldu.'; },
    notify(msg) { this.$store.state.dialog = true; this.$store.state.message = msg; },
  },
};
</script>
